import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Header from "../component/Header";
import CommonBanner from "../component/CommonBanner";
import Footer from "../component/Footer";
import { Col, Container, Row } from "react-bootstrap";
import BookIcon from '../assets/images/resources/icon.svg'
import RightArrow from '../assets/images/resources/arrow.svg'
import ExploreResultLocations from "../component/ExploreResultLocations";
import HomeRealEstateAgentForm from "../component/HomeRealEstateAgentForm";
import { resources } from "../data/resourcesData";

const categories = [
  { name: "Home Buying Guide", slug: "home-buying-guide" },
  { name: "Foreclosure Center", slug: "foreclosure-center" },
  { name: "Down Payment Assistance", slug: "down-payment-assistance" },
  { name: "Rent With JamboBay", slug: "rent-with-jambobay" },
  { name: "Renters Insurance", slug: "renters-insurance" },
  { name: "Rent Guide", slug: "rent-guide" },
  { name: "Commercial Lease Agreement", slug: "commercial-lease-agreement" },
  { name: "Commercial Property Management", slug: "commercial-property-management" },
  { name: "Lease Guide", slug: "lease-guide" }
];

function Resources() {
  const [activeCategory, setActiveCategory] = useState(categories[0].name);
  const navigate = useNavigate();

  const handleCategoryClick = (category) => {
    setActiveCategory(category.name);
    navigate(`/resources/${category.slug}`);
  };

  return (
    <>
      <div className="main resources-page">
        <Header />
        <CommonBanner title="Resources" />
        <section className="resources-section common-padding">
          <Container>
            <Row>
              <Col lg={3} md={4}>
                <div className="resources-sidebar">
                  <h3>Explore All Resources</h3>
                  <ul>
                    {categories.map((category) => (
                      <li key={category.slug} className={category.name === activeCategory ? "active" : ""}>
                        <button type="button" onClick={() => handleCategoryClick(category)}>
                          {category.name}
                        </button>
                      </li>
                    ))}
                  </ul>
                </div>
              </Col>
              <Col lg={9} md={8}>
                <div className="resources-list">
                  {resources.map((resource) => (
                    <Link
                      to={`/resources/${resource.slug}`}
                      className="resource-item"
                      key={resource.slug}
                    >
                      <div className="resource-icon">
                        <img src={BookIcon} alt="" />
                      </div>
                      <div className="resource-content">
                        <h4>{resource.title}</h4>
                        <p>{resource.description}</p>
                      </div>
                      <div className="resource-arrow">
                        <img src={RightArrow} alt="" />
                      </div>
                    </Link>
                  ))}
                </div>
              </Col>
            </Row>
          </Container>
        </section>
        <HomeRealEstateAgentForm />
        <ExploreResultLocations />
        <Footer />
      </div>
    </>
  );
}

export default Resources;